export default "__VITE_ASSET__D5F6q6zg__"